// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"webCam_wrapper__bLS2j","description":"webCam_description__2Eu2R","imageMobile":"webCam_imageMobile__F-KmH","imageDesktop":"webCam_imageDesktop__3Uqy8"};